// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iu","advertCardHeader__actions":"c-a_iv","advertCardHeader__bottomLabel":"c-a_iw"};